<template>
    <div class="animated fadeIn">
      <div class="row">
        <div class="col-sm-12 vh-header d-flex flex-column pr-0">
          <div class="card flex-1-auto h-100 overflow-auto">
              <div class="card-header card-header-with-button">
                 <h5>{{$t('CHECKLISTITEMS')}}</h5>
                 <div>
                      <button  type="button" class="btn-bis btn-primary" @click="showModal()">{{$t('NEW')}}</button>
                  </div>
              </div>
              <div class="card-body" v-if="data.root == null || !data.root.length">
                <p class="center">{{$t('NODATAFOUND')}}</p>
              </div>
              <div class="table-responsive h-100 flex-1-auto" v-if="data.root != null && data.root.length">
                <table class="table table-bis">
                  <thead>
                    <tr>
                      <th>{{$t('ID')}}</th>
                      <th>{{$t('NAME')}}</th>
                      <th>{{$t('ACTION')}}</th>
                    </tr>
                  </thead>
                  <draggable v-model="data.root" @start="drag=true" @end="drag=false" @change="changeOrder" tag="tbody">
                      <tr v-for="item in data.root" :key="item.checkListItemId" aria-rowindex="1" class=" table-ellipsis">
                          <td>{{item.checkListItemId}}</td>
                          <td>{{item.name}}</td>
                          <td class="table-buttons">
                                <b-button type="reset" class="btn-table table-btn-tertiary ml-2"  @click="showModal(item)">{{$t('EDIT')}}</b-button>
                                <b-button type="reset" class="btn-table table-btn-delete ml-2" @click="deleteRow(item.checkListItemId)">{{$t('DELETE')}}</b-button>
                            </td>
                      </tr>
                  </draggable>
                </table>
              </div>
              <pagination
                  v-bind:totalCount="data.totalCount"
                  v-model="pagination">
              </pagination>
            </div>
          </div>
      </div>
      <b-modal ref="formmodal" centered ok-title="submit" hide-header hide-footer no-close-on-backdrop no-close-on-esc>
          <div class="modal-header">
              <div class="modal-title">
                  <h5>{{$t('CHECKLISTITEMS')}}</h5>
              </div>
              <button type="button" aria-label="Close" @click="hideModal()" class="close"><img src="../../../assets/img/icon-close.svg"></button>
          </div>
          <div class="d-block mt-2 modal-content-inside">
              <CheckListItemsForm v-bind:formData="formData" v-bind:formError="formError"></CheckListItemsForm>
  
              <div class="text-center mt-lg">
                  <b-btn class="mr-2 btn-bis btn-cancel" @click="hideModal()">{{$t('CANCEL')}}</b-btn>
                  <b-btn class="btn-bis btn-primary" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
              </div>
          </div>
      </b-modal>
    </div>
  </template>
  
  <script>
  
  import { mapGetters } from 'vuex';
  import Api from '@/api/check_list/CheckListItems.js';
  import CheckListItemsForm from './CheckListItemsForm.vue';
  
  export default {
      name: 'CheckListItems',
      components:
      {
        CheckListItemsForm
      },
      data()
      {
          const me = this;
  
          me.formDataField = {
              name: '',
          };
  
          return {
              loading: true,
              data: {},
              companyData: {},
              formError: {},
              formData: {...me.formDataField},
              pagination: {
                  query: '',
                  currentPage: 1,
                  limit: 25,
              },
              searchTimeout: false,
          };
      },
      created()
      {
          const me = this;
          me.getData();
      },
      methods:
    {
        async changeOrder(item)
        {
            const me = this;
            try
            {
                const { moved } = item;

                const movedData = moved.element;

                let newIndex = moved.newIndex * 10 + 1;

                if (moved.newIndex === me.data.root.length - 1)
                {
                    newIndex += 10;
                }

                const data = await Api.save(
                    {
                        id: movedData.checkListItemId,
                        orderNum: newIndex,
                    },
                );
                me.$notify.notice(data);
                me.getData();
            }
            catch (e)
            {
                console.log(e);
                me.$notify.notice(e);
            }
        },
        async getData()
        {
            const me = this;
            try
            {
                me.loading = true;
                const data = await Api.selectRow(me.getParams);
                if (data.error && data.error === true)
                {
                    throw (data);
                }
                me.data = data;
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
            finally
            {
                me.loading = false;
            }
        },
        async deleteRow(id)
        {
            const me = this;
            me.$store.commit('setModalAlert',
                {
                    text: me.$i18n.t('AREYOUSHURE'),
                    async btnAction()
                    {
                        const data = await Api.deleteRow({ id });
                        me.$notify.notice(data);
                        me.getData();
                    },
                });
        },
        showModal(item)
        {
            const me = this;
            if (typeof item !== 'undefined')
            {
                me.formData = { ...item };
            }
            this.$refs.formmodal.show();
        },
        async submitData(item)
        {
            const me = this;
            try
            {
                me.loading = true;
                if (typeof item.checkListItemId !== 'undefined')
                {
                    item.id = item.checkListItemId;
                    delete (item.checkListItemId);
                }
                
                item.checkListId = me.$route.params.checkListId;
                const data = await Api.save(item);
                if (data.error)
                {
                    me.formError = data;
                    throw (data);
                }
  
                me.$notify.notice(data);
                me.getData();
                me.hideModal();
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
            finally
            {
                me.loading = false;
            }
        },
        hideModal()
        {
            const me = this;
  
            me.formError = {};
            me.formData = {...me.formDataField},
            this.$refs.formmodal.hide();
        },
    },
      watch:
      {
          pagination:
          {
              deep: true,
              handler()
              {
                  const me = this;
  
                  if (me.searchTimeout !== false)
                  {
                      clearTimeout(me.searchTimeout);
                  }
  
                  me.searchTimeout = setTimeout(() =>
                  {
                      me.getData();
                      me.searchTimeout = false;
                  }, 300);
              },
          },
      },
      computed:
    {
        ...mapGetters([
            'globals',
        ]),
        getParams()
        {
            const me = this;
            const data = { ...me.pagination, ...me.paginationSec };
            data.start = (data.currentPage - 1) * data.limit;
            data.checkListId = me.$route.params.checkListId;
            return data;
        }
    },
  };
  </script>
  